import { render, staticRenderFns } from "./addBackground.vue?vue&type=template&id=87bba7dc&"
import script from "./addBackground.vue?vue&type=script&lang=js&"
export * from "./addBackground.vue?vue&type=script&lang=js&"
import style0 from "./addBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports